<template>
  <div class="d-flex flex-column row-gap-3" data-locator="features">
    <div class="text--medium text--extra-bold text-text-primary">
      {{ $t('project.project-settings.ProjectSettingsFeatures.title') }}
    </div>

    <!-- CHECKLIST -->
    <AppCard elevation="0" data-locator="checklist-settings">
      <p class="mb-4 text--medium text--bold text-text-primary">
        {{ $t('project.project-settings.ProjectSettingsFeatures.checklist.title') }}
      </p>

      <AppCard class="mb-2" data-locator="double-validation">
        <p class="text--small text--bold text-text-primary">
          {{ $t('project.project-settings.ProjectSettingsFeatures.checklist.doubleValidation') }}
        </p>

        <div class="d-flex justify-space-between align-center mt-2">
          <p class="text--small text-text-secondary">
            {{ $t('project.project-settings.ProjectSettingsFeatures.checklist.doubleValidationLabel') }}
          </p>
          <app-toggle
            :model-value="enableValidationChecklistItemDeletion"
            readonly
            class="mt-n1"
            hide-details
            :loading="patchRoomPending"
            @click="!patchRoomPending && prepareEnableValidationChecklistItemDeletion()"
          >
          </app-toggle>
        </div>
      </AppCard>
    </AppCard>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  import AppCard from '@/common/AppCard.vue'
  import { toast } from '@/common/utils/toast'
  import { PATCH_ROOM } from '@/store/modules/room/action_types'
  import { SET_CURRENT_ROOM } from '@/store/modules/room/mutation_types'

  export default {
    name: 'ProjectSettingsFeatures',
    components: { AppCard },
    props: {
      mnemo: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapState('room', ['currentRoom', 'patchRoomPending']),
      enableValidationChecklistItemDeletion () {
        return this.currentRoom?.enableValidationChecklistItemDeletion
      },
    },
    methods: {
      ...mapActions('room', [PATCH_ROOM]),
      async prepareEnableValidationChecklistItemDeletion () {
        try {
          await this.PATCH_ROOM({
            mnemo: this.mnemo,
            data: {
              optEnableValidationChecklistItemDeletion: !this.enableValidationChecklistItemDeletion,
            },
          })
          this.currentRoom.enableValidationChecklistItemDeletion = !this.enableValidationChecklistItemDeletion
          this.$store.commit(`room/${SET_CURRENT_ROOM}`, this.currentRoom)

          toast.success(this.$t('project.project-settings.ProjectSettingsFeatures.checklist.setDoubleValidationSuccess'))
        } catch (error) {
          console.error(error)
          toast.error(this.$t('project.project-settings.ProjectSettingsFeatures.checklist.setDoubleValidationError'))
        }
      },
    },
  }
</script>
